export default __webpack_public_path__ + "static/google-cloud-79cae9be2fa5d7cd2b61a8b5db166b38.png";